import { useFlags } from "launchdarkly-react-client-sdk";

const ENDASH = "–";

type ScheduledMaintenanceFlag = {
  enabled?: boolean;
  dateTime?: string;
};

export default function ScheduledMaintenanceBanner() {
  const { scheduledMaintenance } = useFlags() as {
    scheduledMaintenance?: ScheduledMaintenanceFlag;
  };

  if (!scheduledMaintenance?.enabled) {
    return null;
  }

  return (
    <div className="block w-full bg-orange-100 p-4 box-border leading-6 text-center font-sans text-[14px]">
      Heads up! We’re performing scheduled maintenance on{" "}
      <span className="font-semibold">
        {scheduledMaintenance?.dateTime || ENDASH}
      </span>
      . The site will be temporarily unavailable. Thanks for your patience!
    </div>
  );
}
